import React, { useContext, useEffect } from "react";
import BlogContext from "../../Context/BlogContext";

import ScrollToTopOnMount from "../utilities/ScrollToTopOnMount";
import img from "../../images/blog/uno.jpg";
import Loading from "../utilities/Loading";
import { useParams } from "react-router-dom";
import OtherPost from "./OtherPost";
const PostCompletoBlog = () => {
  let { id } = useParams();

  const { postreading, otherposts, seleccionarPost } = useContext(BlogContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    seleccionarPost(id);
  }, [id]);
  const postActivo = postreading[0];
  const { parrafos, imagenes, avatar } = postActivo;

  if (!imagenes) {
    return <Loading />;
  }
  console.log();

  return (
    <>
      <ScrollToTopOnMount />
      <div className="c-blog">
        <div className="content-post">
          <h2 className="blog-title">{postActivo.posttitle}</h2>
          <p className="blog-subtitle">{postActivo.postsubtitle}</p>
          <div className="blog-info">
            <img src={avatar} alt="" className="img_blog-avatar" />
            <div className="">
              <p>{postActivo.postauthor}</p>
              <p>
                {postActivo.postdate.getDay()}/{postActivo.postdate.getMonth()}/
                {postActivo.postdate.getYear()} |
                <span className="text-secondary">
                  {postActivo.posttimetoread} minutos para leer
                </span>
              </p>
            </div>
          </div>
          <img src={imagenes.principal} alt="" className="img_blog-principal" />
          <div className="blog-principal-text">{parrafos[0]}</div>
          <img src={imagenes.dos} alt="" className="img_blog-principal" />
          <div className="blog-principal-text">{`${parrafos[1]}`}</div>
          <img src={imagenes.tres} alt="" className="img_blog-principal" />
          <div className="blog-principal-text">{parrafos[2]}</div>
          <div className="blog-principal-text">{parrafos[3]}</div>
          <div className="blog-principal-text">{parrafos[4]}</div>
          <section className="more-post">
            <h2>Quizá te interese</h2>
            {otherposts.map((otherpost) => (
              <OtherPost otherpost={otherpost} />
            ))}
          </section>
        </div>
      </div>
    </>
  );
};

export default PostCompletoBlog;
